var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    viewBox: "0 0 41 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 18.5201C18.469 19.9941 17.5625 21.3039 16.37 22.3201C15.1563 23.3545 13.7015 24.0665 12.14 24.3901C10.5689 24.7096 8.94272 24.6305 7.41 24.1601C5.8897 23.6873 4.5137 22.8376 3.41 21.6901C2.46386 20.7728 1.71224 19.6743 1.2 18.4601C0.717632 17.2767 0.479528 16.0079 0.499995 14.7301C0.518277 12.8994 0.910964 11.0917 1.6539 9.4184C2.39683 7.74508 3.47429 6.24148 4.82 5.0001C7.20002 2.4071 10.4879 0.831205 14 0.600098C11.5 2.2101 9.9 4.0001 9.34 6.0001L9.16 6.6301H10.22C12.5504 6.61079 14.8053 7.45507 16.55 9.0001C17.477 9.83792 18.2195 10.8596 18.73 12.0001C19.2405 13.1276 19.4998 14.3525 19.49 15.5901C19.4935 16.5907 19.3278 17.5847 19 18.5301",
    stroke: "url(#paint0_linear_308_71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 18.5201C39.469 19.9941 38.5625 21.3039 37.37 22.3201C36.1563 23.3545 34.7015 24.0665 33.14 24.3901C31.5689 24.7096 29.9427 24.6305 28.41 24.1601C26.8897 23.6873 25.5137 22.8376 24.41 21.6901C23.4639 20.7728 22.7122 19.6743 22.2 18.4601C21.7176 17.2767 21.4795 16.0079 21.5 14.7301C21.5183 12.8994 21.911 11.0917 22.6539 9.4184C23.3968 7.74508 24.4743 6.24148 25.82 5.0001C28.2 2.4071 31.4879 0.831205 35 0.600098C32.5 2.2101 30.9 4.0001 30.34 6.0001L30.16 6.6301H31.22C33.5504 6.61079 35.8053 7.45507 37.55 9.0001C38.477 9.83792 39.2195 10.8596 39.73 12.0001C40.2405 13.1276 40.4998 14.3525 40.49 15.5901C40.4935 16.5907 40.3278 17.5847 40 18.5301",
    stroke: "url(#paint1_linear_308_71)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_71",
    x1: 19.52,
    y1: 12.5401,
    x2: 0.479995,
    y2: 12.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_71",
    x1: 40.52,
    y1: 12.5401,
    x2: 21.48,
    y2: 12.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#673AB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512DA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 25,
    fill: "white",
    transform: "translate(41 25) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.fda2a055a4c90b2de07f0e27148d3bcd.svg";
export { ForwardRef as ReactComponent };